<template>
  <!-- <Form v-slot="{ errors }" @submit="submitForm"> -->
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>{{ id ? 'Cập nhật cửa hàng' : 'Thêm mới cửa hàng' }}</h1>
      <div class="float-right">
        <button
          type="submit"
          class="font-medium f12 btn btn-outline-primary m-r-10"
          @click="submitForm"
          :disabled="isLoading"
        >
          <b-icon icon="check-lg" aria-hidden="true" />
          {{ id ? 'Cập nhật' : 'Thêm mới' }}
        </button>
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="ReturnToList"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Huỷ bỏ
        </button>
      </div>
      <hr />
    </div>

    <b-row class="px-4">
      <b-col md="6">
        <b-card class="card-section">
          <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
            <form @submit.prevent="handleSubmit(submitForm)">
              <div class="form-item">
                <ValidationProvider rules="required|minMaxName_2" vid="name" name="Tên cửa hàng">
                  <b-row class="form-group" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Tên cửa hàng</b-col>
                    <b-col cols="8" class="form-input">
                      <b-form-input v-model="form.storeName" placeholder="Tên cửa hàng" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
              <div class="form-item">
                <ValidationProvider rules="required" vid="createdStoreDate" name="Ngày tạo">
                  <b-row class="" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Ngày tạo</b-col>
                    <b-col cols="8" class="form-group">
                      <datepicker
                        format="dd/MM/yyyy"
                        :language="vi"
                        class="receipt-date"
                        v-model="form.createdStoreDate"
                        placeholder="Chọn ngày tạo"
                      ></datepicker>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
              <div class="form-item">
                <ValidationProvider :rules="id ? '' : 'required'" vid="mo" name="Merchant Owner">
                  <b-row class="" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Merchant Owner</b-col>
                    <b-col cols="8" class="form-group">
                      <Select2
                        :required="!!id"
                        :disabled="!!id"
                        v-model="form.merchantOwnerId"
                        :options="moOptions"
                        :settings="moSettings"
                        placeholder="Tìm kiếm merchant owner"
                        @change="onChangeMo"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
              <div class="form-item">
                <ValidationProvider :rules="id ? '' : 'required'" vid="ma" name="Merchant Account">
                  <b-row class="" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Merchant Account</b-col>
                    <b-col cols="8" class="form-group">
                      <Select2
                        :disabled="!!id"
                        :required="!!id"
                        v-model="form.mcAccountId"
                        :options="maOptions"
                        :settings="maSettings"
                        placeholder="Tìm kiếm merchant account"
                        @change="onChangeMa"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
              <div class="form-item">
                <ValidationProvider rules="required" vid="regionCode" name="Vùng merchant">
                  <b-row class="" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Vùng merchant</b-col>
                    <b-col cols="8" class="form-group">
                      <Select2
                        v-model="form.regionCode"
                        :options="dataConfigRegionMC"
                        @change="queryMcProvince($event)"
                        placeholder="Vùng merchant"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
              <div class="form-item">
                <ValidationProvider rules="required" vid="provinceCode" name="Tỉnh/Thành">
                  <b-row class="" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Tỉnh/Thành</b-col>
                    <b-col cols="8" class="form-group">
                      <Select2
                        v-model="form.provinceCode"
                        :options="dataProvinceMC"
                        placeholder="Tỉnh/Thành"
                        :disabled="!form.regionCode || form.regionCode === '0'"
                        @change="getMcDistrict($event)"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
              <div class="form-item">
                <ValidationProvider rules="required" vid="districtCode" name="Quận/Huyện">
                  <b-row class="" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Quận/Huyện</b-col>
                    <b-col cols="8" class="form-group">
                      <Select2
                        v-model="form.districtCode"
                        :options="dataDistrict"
                        placeholder="Quận/Huyện"
                        :disabled="!form.provinceCode || form.provinceCode === '0'"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
              <div class="form-item">
                <ValidationProvider vid="address" name="Địa chỉ" rules="required|minMaxName_2">
                  <b-row class="form-group" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Địa chỉ</b-col>
                    <b-col cols="8" class="form-input">
                      <b-form-input v-model="form.address" placeholder="Địa chỉ" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
              <div class="form-item">
                <ValidationProvider rules="required" vid="status" name="Trạng thái hoạt động">
                  <b-row class="" slot-scope="{ errors }">
                    <b-col cols="4" class="form-label require">Trạng thái hoạt động</b-col>
                    <b-col cols="8" class="form-group">
                      <Select2
                        v-model="form.status"
                        :options="storeOptions"
                        placeholder="Trạng thái hoạt động"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card class="card-section mb-3 mt-3 mt-md-0">
          <UploadMultiple2
            :imagesPreview="form.images"
            :title="'Ảnh chi nhánh'"
            :maxFile="100"
            titleTag="h2"
            :uploadToApi="false"
            :isDragging="true"
            titleClass="form-inner-heading"
            ref="uploadImages"
          />
        </b-card>

        <b-card class="card-section">
          <UploadMultiple2
            :imagesPreview="form.verificationImage"
            :title="'Ảnh giấy tờ xác minh'"
            :maxFile="100"
            titleTag="h2"
            :uploadToApi="false"
            :isDragging="true"
            titleClass="form-inner-heading"
            ref="uploadVerificationImage"
          />
        </b-card>
      </b-col>
    </b-row>

    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
    <!-- </Form> -->
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { showMess } from '@/config/utils'
  import cloneDeep from 'lodash/cloneDeep'
  import { Create, Detail, Update } from '@/services/customer-support/store'
  import { Detail as MoDetail, List as ListMo } from '@/services/customer-support/merchant-owner'
  import { Detail as MaDetail, Search as ListMa } from '@/services/customer-support/account'
  import { StaffService } from '@/services/staff.service'
  import { SearchByCode } from '@/services/customer-support/location'
  import { CommonService } from '@/services/common.service'
  import { StoreState } from '@/constant/customerSupport'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import moment from 'moment'
  import UploadMultiple2 from '@/components/cskh/UploadMultiple2.vue'
  export default {
    name: 'CreateStore',
    components: {
      UploadMultiple2,
    },
    data() {
      return {
        isLoading: false,
        id: null,
        fileUploads: [],
        moOptions: [],
        maOptions: [],
        storeOptions: [],
        storeStateOptions: StoreState,
        listSearchMa: [],
        storeState: [],
        moId: '',
        maId: '',
        vi,
        form: {
          mcAccountId: '',
          merchantOwnerId: '',
          storeName: '',
          regionCode: '',
          provinceCode: '',
          districtCode: '',
          address: '',
          status: 'ACTIVE',
          // storeState: "NEW",
          images: [],
          verificationImage: [],
          createdStoreDate: moment().format('MM/DD/YYYY'),
        },
        dataConfigRegionMC: [],
        dataProvinceMC: [],
        dataDistrict: [],
        dataDistrictName: [],
        tLoadMo: undefined,
        moSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              // const queryString = txtSearch ? `{textSearch} LIKE '''${txtSearch}'''` : ''
              if (this.tLoadMo) {
                clearTimeout(this.tLoadMo)
              }
              this.tLoadMo = setTimeout(() => {
                ListMo({
                  showFields: ['id', 'ownerName', 'email'],
                  limit: 10,
                  page: 1,
                  // queryString,
                  keyWord: txtSearch,
                  sort: {
                    direction: 'ASC',
                    properties: ['ownerName'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.list?.map(item => {
                          return {
                            id: item.id,
                            text: item.ownerName || item.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        tLoadMa: undefined,
        maSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [`{textSearch} LIKE '''${txtSearch}'''`]
              if (this.form.merchantOwnerId) {
                querys.push(`{merchantOwnerId} == '''${this.form.merchantOwnerId}'''`)
              }

              if (this.tLoadMa) {
                clearTimeout(this.tLoadMa)
              }
              this.tLoadMa = setTimeout(() => {
                ListMa({
                  showFields: ['id', 'accountName', 'email', 'role', 'merchantOwnerId'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    this.listSearchMa =
                      res.data.listData?.map(item => {
                        return {
                          id: item.id,
                          text: item.accountName || item.email,
                          merchantOwnerId: item.merchantOwnerId,
                        }
                      }) || []
                    success({
                      results: this.listSearchMa,
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
      }
    },

    async created() {
      this.id = this.$router.currentRoute.params.id
      // await this.configSystem()
      // await this.getMcRegions()
      // if (this.id) {
      //   await this.getStoreDetail()
      //   await this.getOptions()
      // }
      // if (this.$route.query.maId) {
      //   this.form.mcAccountId = this.$route.query.maId
      //   await this.getMaOptions()
      //   this.form.merchantOwnerId = this.moId
      //   await this.getMoOptions()
      // }
      this.maId = this.$route.query.maId
    },

    async mounted() {
      await this.configSystem()
      await this.getMcRegions()
      if (this.id) {
        await this.getStoreDetail()
        await this.getOptions()
      }
      if (this.maId) {
        this.form.mcAccountId = this.maId
        await this.getMaOptions()
        this.form.merchantOwnerId = this.moId
        await this.getMoOptions()
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      ReturnToList() {
        this.$router.push(`/customer-support/store`)
      },
      async getOptions() {
        await Promise.allSettled([this.getMoOptions(), this.getMaOptions()]).catch(e =>
          console.log(e)
        )
      },
      async getMoOptions() {
        try {
          if (this.form.merchantOwnerId) {
            const res = await MoDetail(this.form.merchantOwnerId)
            if (res.data) {
              this.moOptions = [
                {
                  text: res.data.accountName || res.data.email,
                  ...res.data,
                },
              ]
            }
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async getMaOptions() {
        try {
          if (this.form.mcAccountId) {
            const res = await MaDetail(this.form.mcAccountId)
            if (res.data) {
              this.maOptions = [
                {
                  text: res.data.accountName || res.data.email,
                  ...res.data,
                },
              ]
              this.moId = res.data?.merchantOwnerId
            }
          }
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      async getStoreDetail() {
        try {
          this.isLoading = true
          const res = await Detail(this.id)

          if (res.data.regionCode) {
            await this.getProvinceRegionList(res.data.regionCode)
          }
          if (res.data.provinceCode) {
            await this.getDistrictList(res.data.provinceCode)
          }
          this.form = res.data
          this.form.mcAccountId = res.data.merchantAccountId
          this.form.merchantOwnerId = res.data.merchantOwnerId
          this.form.createdStoreDate = res.data.createdStoreDate
          ;(res.data.images?.length || 0) > 0 && (this.form.images = res.data.images)
          ;(res.data.verificationImage?.length || 0) > 0 &&
            (this.form.verificationImage = res.data.verificationImage)
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
      async validateForm() {
        const isValid = await this.$refs.observer.validate()
        return isValid
      },

      async submitForm() {
        const isValid = await this.validateForm()
        if (!isValid) {
          return showMess(
            this,
            'Error',
            'Hãy kiểm tra lại thông tin nhập',
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
        if (this.id) {
          await this.edit()
        }
        if (!this.id) {
          await this.create()
        }
      },
      async create() {
        try {
          this.isLoading = true

          const images = await this.$refs.uploadImages.saveData()
          const verificationImage = await this.$refs.uploadVerificationImage.saveData()
          const params = cloneDeep(this.form)
          params.images = images
          params.verificationImage = verificationImage || []
          params.createdStoreDate = moment(params.createdStoreDate, 'MM/DD/YYYY').valueOf()

          const res = await Create(params)
          if (res && res.code === 1000) {
            this.showSuccessMx(res.message)
            setTimeout(() => {
              this.$router.push('/customer-support/store')
            }, 1000)
          }
        } catch (e) {
          this.showFailMx(e.message)
          // setTimeout(() => {
          //   this.$router.push("/customer-support/store");
          // }, 3000);
        } finally {
          this.isLoading = false
        }
      },
      async edit() {
        try {
          this.isLoading = true
          const images = await this.$refs.uploadImages.saveData()
          const verificationImage = await this.$refs.uploadVerificationImage.saveData()
          const params = cloneDeep(this.form)
          params.images = images
          params.verificationImage = verificationImage || []
          params.createdStoreDate = moment(params.createdStoreDate, 'MM/DD/YYYY').valueOf()
          params.createdDate = params.createdStoreDate

          const res = await Update(params.id, params)
          if (res && res.code === 1000) {
            this.showSuccessMx(res.message)

            setTimeout(() => {
              this.getStoreDetail()
            }, 500)

            // modal.then(() => {
            //   this.$router.push("/customer-support/store");
            // });
            // setTimeout(() => {
            //   this.$router.push('/customer-support/store')
            // }, 1000)
          }
        } catch (e) {
          this.showFailMx(e.message)
          // setTimeout(() => {
          //   this.$router.push('/customer-support/store')
          // }, 3000)
        } finally {
          this.isLoading = false
        }
      },
      async onChangeMo() {
        this.form.mcAccountId = ''
        await this.getMoOptions()
      },

      async onChangeMa(val) {
        if (!this.form.merchantOwnerId)
          this.form.merchantOwnerId = this.listSearchMa.find(
            item => item.id === val
          )?.merchantOwnerId
        await Promise.allSettled([this.getMoOptions(), this.getMaOptions()])
      },
      // lấy vùng
      async getRegions() {
        try {
          const data = await StaffService.getRegions()
          if (data.data.length > 0) {
            this.dataConfigRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (e) {
          console.log(e)
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.form.businessProvinceCode = ''
          this.dataProvince = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy vùng mc
      async getMcRegions() {
        try {
          this.isLoading = true
          const data = await StaffService.getRegionsConfig()
          if (data.data.length > 0) {
            this.dataConfigRegionMC = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
                idRegion: e.id,
              }
            })
            this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (e) {
          this.isLoading = false
          console.log(e)
        }
        this.isLoading = false
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e) {
        this.form.provinceCode = ''
        this.form.districtCode = ''
        await this.getProvinceRegionList(e)
      },
      async getProvinceRegionList(e) {
        try {
          const data = await StaffService.getProvinceByRegionId({
            regionId: [this.dataConfigRegionMC.find(s => s.id === e).idRegion],
          })
          if (data.data.length > 0) {
            this.dataProvinceMC = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvinceMC.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },

      // lấy quận mc
      async getMcDistrict(event) {
        this.form.districtCode = ''
        await this.getDistrictList(event)
      },
      async getDistrictList(event) {
        try {
          this.form.districtCode = ''
          const data = await SearchByCode({ code: event })
          if (data.data.length > 0) {
            this.dataDistrict = data.data
              .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
              .map(e => {
                return {
                  id: e.locationCode,
                  text: e.localName,
                }
              })
          }
          this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
        } catch (e) {
          console.log(e)
        }
      },
      configSystem() {
        this.isLoading = true
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.storeOptions = data.data.storeStatus.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                }
              })
            }
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            console.error(error)
          })
      },
    },
  }
</script>

<style scoped lang="scss">
  .card-section {
    width: 100%;
    -webkit-box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }
  .header-section {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    position: relative;
    margin-left: 10px;

    &::before {
      content: ' ';
      position: absolute;
      width: 4px;
      height: 24px;
      background: #13569f;
      left: -10px;
    }
  }

  .form-item {
    &:first-child {
      margin-top: 0;
    }

    .form-label {
      font-weight: 400;
      font-size: 14px;
      color: #2a2a2a;

      &.require::after {
        content: '*';
        color: #f00;
        margin-left: 4px;
      }
    }

    .form-input {
      width: 60%;

      .error {
        color: #f00;
      }
    }
  }

  .no-data {
    width: 100%;
    color: #999;
    border: 1px solid #ddd;
    height: 60px;
    align-items: center;
    border-radius: 5px;
    display: flex;
    justify-content: center;
  }
</style>
